export interface IGeoCoordinate {
  lat: number;
  lng: number;
}

export interface IUserGeolocation {
  position: IGeoCoordinate,
  address: string;
};
